import { createListStore } from './useListStore'

export const useTeamStore = createListStore()

